import { GenData, Provider } from '@educraft/base';
import { PageGen, PdfRect, PdfUnit, PdfBrush, ETextAlign } from '../pdf/pdf';
import { GUtil } from '../pdf/gutil';
import { IColorSchema } from './colorSchema';
import { ExeItem, ExeResults } from './exeProject';

export const IExerciseSymbol = Symbol('IExercise');

export interface ExerciseData {
  page: PageGen;
  rect: PdfRect;
  pageIndex: number;
  exerciseIndex: number;
  data: GenData;
  colorSchema: IColorSchema;
  item: ExeItem;
  results: ExeResults;
  provider: Provider;
}

export function addResult(data: ExerciseData, key: string, value: string): void {
  data.results.add(`${data.pageIndex + 1}.${data.exerciseIndex + 1}`, key, value);
}

export function addResultSimple(data: ExerciseData, value: string): void {
  addResult(data, '', value);
}

export interface IExercise {
  readonly name: string;
  readonly fixedHeight: number; // 0 = flexible
  readonly noWindow: boolean;
  readonly injectEq: boolean;
  readonly injectAbc: boolean;
  draw(data: ExerciseData): void;
}

export function drawQuestionResult(data: ExerciseData, label: string, rect: PdfRect): void {
  const margin = PdfUnit.FromMillimeters(1);
  const ss = data.page.measureString(label, GUtil.exerciseFont);
  data.page.drawString(
    label,
    GUtil.exerciseFont,
    PdfBrush.Black,
    null,
    rect,
    ETextAlign.CenterLeft
  );

  const a = new PdfRect(
    rect.x + ss.width + margin,
    rect.y,
    rect.width - ss.width - margin,
    rect.height
  );
  data.colorSchema.drawResult(data.page, a);
}
